const peiSaee10Forms = {
    Saee10a: 1602,
    Saee10b: 1603,
    Saee10c: 1604,
    Saee10d: 1605    
  };
  
  export default peiSaee10Forms;
  